<template>
  <div class="refund-apply" mg-stat-page="haowu_aftersale">
    <fixed-header title="申请售后"></fixed-header>
    <div class="refund-apply__main scroll-touch">
      <section class="refund-apply__goods">
        <img :src="goodsInfo.originalImg"/>
        <div>
          <p>{{ goodsInfo.goodsName }}</p>
          <p>{{ goodsInfo.specKeyName }}</p>
        </div>
      </section>
      <section class="refund-apply__picker" @click="isShowTypePicker = true">
        <span>售后类型</span>
        <span>
          {{ form.typeTitle }}
        </span>
        <i class="icon left_arrow"></i>
      </section>
      <section class="refund-apply__reason">
        <p class="refund-apply__common">
          <span>货物状态</span>
          <span>{{ form.statusTitle }}</span>
        </p>
        <p class="refund-apply__picker" @click="isShowReasonPicker = true">
          <span>{{ refundTitle }}原因</span>
          <span class="add_dot">
            {{ form.reason }}
          </span>
          <i class="icon left_arrow"></i>
        </p>
      </section>
      <!--
      <section v-if="isRefund" class="refund-apply__money">
        <span>退款金额</span>
        <span>￥{{ goodsInfo.goods_price }}</span>
      </section>-->
      <section class="refund-apply__remark">
        <span>{{ refundTitle }}说明</span>
        <input-item
            v-model="form.describe"
            class="refund-apply__remark-input"
            placeholder="选填"
            type="text"
            @change="(val) => (form.describe = val)"
        ></input-item>
      </section>
      <!-- 上传凭证 -->
      <div class="refund-apply__certificate" v-if="shippingStatus==1">
        <section>
          <div
              v-for="(ele, index) in form.imgs"
              :key="index"
              class="refund-apply__img"
          >
            <img :src="ele.src" alt=""/>
            <i class="icon comment_del" @click="delteImg(index, ele.tagId)"></i>
          </div>
          <div v-if="isShowInput" class="refund-apply__upload">
            <input
                id="upload"
                accept="image/*"
                multiple
                type="file"
                @change="(e) => uploadPic(e)"
            />
            <i class="icon camera"></i>
            <span>上传凭证</span>
          </div>
          <div class="remark">
            备注：请上传物损图片、快递外包装图片、快递面单图片，以便商家更好的解决问题哦
            <div>
              <span>示例图</span>
              <img :src="demo1" alt=""/>
              <img :src="demo2" alt=""/>
              <img :src="demo3" alt=""/>
            </div>
          </div>
        </section>
      </div>
    </div>
    <refund-picker
        :defaultKey="form.reasonKey"
        :headerTitle="refundTitle + '原因'"
        :isShow="isShowReasonPicker"
        :option="useReasonOption"
        @changeVisible="(val) => (isShowReasonPicker = val)"
        @confirm="getReason"
    >
    </refund-picker>
    <refund-picker
        :defaultKey="form.type"
        :isShow="isShowTypePicker"
        :option="useTypeOption"
        headerTitle="售后类型"
        @changeVisible="(val) => (isShowTypePicker = val)"
        @confirm="getType"
    >
    </refund-picker>

    <div
        :mg-stat-lob="'order_id=' + form.orderId"
        class="refund-apply__button"
        mg-stat-click
        mg-stat-custom="label=btn&cont=提交&direct=cntp&addr="
        @click="submitForm"
    >
      <button>提交</button>
    </div>
  </div>
</template>

<script>
import demo1 from 'assets/img/refund/1.png';
import demo2 from 'assets/img/refund/2.png';
import demo3 from 'assets/img/refund/3.png';
import FixedHeader from 'components/common/FixedHeader';
import RefundPicker from 'components/refund/RefundPicker';
import InputItem from 'components/common/InputItem';
import * as orderApi from 'apis/order';
import _ from 'lodash';
import { APPLY_EXCHANGE_GOODS, APPLY_RETURN_GOODS, APPLY_RETURN_MONEY } from 'constants/refund';
import { guid } from 'utils';

export default {
  components: {
    FixedHeader,
    RefundPicker,
    InputItem,
  },
  data() {
    const {
      id,
      recId,
      orderId,
      originalImg,
      goodsName,
      specKeyName,
      invoiceStatus,
      goodsFrom,
      shippingStatus,
    } = this.$route.query;
    return {
      id,
      demo1,
      demo2,
      demo3,
      invoiceStatus,
      goodsFrom,
      shippingStatus,
      goodsInfo: {
        originalImg,
        goodsName,
        specKeyName,
      },
      form: {
        recId,
        orderId,
        type: '',
        typeTitle: '',
        statusTitle: '已收到货',
        reasonKey: '',
        reason: '',
        describe: '',
        files: [],
        imgs: [],
        up_imgs: [],
      },
      refundType: '',
      refundReason: '',
      isShowTypePicker: false,
      isShowReasonPicker: false,
      // isShowInput: true,
      isEditRefund: false,
      lmReasonList: [],
      useReasonOption: [],
      reasonOption: [
        { value: 1, title: '我不想要了' },
        { value: 2, title: '大小／尺寸与商品描述不符' },
        { value: 3, title: '颜色／图案／款式与商品描述不符' },
        { value: 4, title: '材质面料与商品描述不符' },
        { value: 5, title: '功能／效果与商品描述不符' },
        { value: 6, title: '做工问题' },
        { value: 7, title: '缩水／褪色' },
        { value: 8, title: '包装／商品破碎／污渍' },
        { value: 9, title: '卖家发错货' },
      ],
      useTypeOption: [],
      typeOption: [
        { value: APPLY_RETURN_MONEY, title: '仅退款(已与客服沟通无需退货)' },
        { value: APPLY_RETURN_GOODS, title: '退货退款' },
        { value: APPLY_EXCHANGE_GOODS, title: '换货' },
      ],
      typeOption2: [{ value: APPLY_EXCHANGE_GOODS, title: '换货' }],
      typeOption3: [{ value: APPLY_RETURN_MONEY, title: '仅退款(已与客服沟通无需退货)' }, { value: APPLY_RETURN_GOODS, title: '退货退款' }],
      typeOption4: [
        { value: APPLY_RETURN_GOODS, title: '退货退款' },
        { value: APPLY_EXCHANGE_GOODS, title: '换货' },
      ],
      typeOption5: [
        { value: APPLY_RETURN_MONEY, title: '仅退款(未发货)' },
      ],
      typeOption6: [
        { value: APPLY_RETURN_GOODS, title: '退货退款' },
      ],
    };
  },
  computed: {
    isRefund() {
      const {
        form: { type },
      } = this;
      return type === APPLY_RETURN_GOODS;
    },
    refundTitle() {
      const {
        isRefund,
        form: { type },
      } = this;
      return isRefund || !type ? '退款' : '换货';
    },
    isShowInput() {
      const {
        form: { imgs },
      } = this;
      return !(imgs.length >= 4);
    },
  },
  created() {
    this.fetchDetail();
    if (this.shippingStatus > 0) {
      this.form.statusTitle = '已收到货';
    } else {
      this.form.statusTitle = '未收到货';
    }
    this.initUseTypeOption();
    this.initUseReasonOption();
  },
  watch: {
    goodsFrom: {
      handler() {
        // this.initUseTypeOption();
      },
      immediate: true,
    },
    refundType: {
      handler(val) {
        if (val) {
          const arr = this.useTypeOption.filter(f => f.value === val);
          const title = arr.length ? arr[0].title : '';
          this.getType({ key: val, title });
        }
      },
      immediate: true,
    },
  },
  methods: {
    getReason({ key, title }) {
      this.form.reasonKey = key;
      this.form.reason = title;
      this.isShowReasonPicker = false;
    },
    async getType({ key, title }) {
      this.form.type = key;
      this.form.typeTitle = title;
      this.isShowTypePicker = false;
      if (this.goodsFrom === 'linkedMall' || this.goodsFrom === 'jdMall') {
        const initRefundData = await orderApi.renderRefund({ orderId: this.form.orderId, bizClaimType: key });
        if (initRefundData.canRefund) {
          this.useReasonOption = initRefundData.reasonList;
          this.lmReasonList = initRefundData.thirdReasonList;
        } else {
          this.$toast(initRefundData.errMsg);
          this.useReasonOption = [];
          this.lmReasonList = [];
        }
        this.form.reasonKey = '';
        this.form.reason = '';
      }
      if (this.isEditRefund && this.useReasonOption.length > 0) {
        const arr2 = this.useReasonOption.filter(f => f.title === this.refundReason);
        this.form.reasonKey = arr2.length ? arr2[0].value : '';
        this.form.reason = this.refundReason;
      }
    },
    async initUseTypeOption() {
      if (this.invoiceStatus === 1 || this.invoiceStatus === 2) {
        this.useTypeOption = this.typeOption2;
      } else if (this.goodsFrom === 'xiaomang') {
        if (this.shippingStatus === 0) {
          this.useTypeOption = this.typeOption5;
        } else {
          this.useTypeOption = this.typeOption4;
        }
      } else if (this.goodsFrom === 'linkedMall' || this.goodsFrom === 'jdMall') {
        const renderRefundType = await orderApi.renderRefundType({ orderId: this.form.orderId });
        if (renderRefundType.canRefund) {
          this.useTypeOption = renderRefundType.refundTypeList;
        } else {
          this.$toast(renderRefundType.errMsg);
          this.useTypeOption = [];
        }
      } else if (this.goodsFrom === 'happygo') {
        if (this.shippingStatus === 0) {
          this.useTypeOption = this.typeOption5;
        } else {
          this.useTypeOption = this.typeOption6;
        }
      } else {
        this.useTypeOption = this.typeOption;
      }
    },
    initUseReasonOption() {
      this.useReasonOption = this.reasonOption;
    },
    async fetchDetail() {
      const { id } = this;
      try {
        if (id) {
          const { goodsInfo, refundInfo } = await orderApi.getRefundDetail({
            id,
          });
          this.isEditRefund = true;
          this.goodsInfo = goodsInfo;
          this.form.id = refundInfo.id;
          this.form.recId = refundInfo.recId;
          this.form.orderId = refundInfo.orderId;
          this.goodsFrom = goodsInfo.goodsFrom;
          this.refundType = refundInfo.type;
          this.refundReason = refundInfo.reason;
          this.form.reason = refundInfo.reason;
          this.form.describe = refundInfo.describe;
          if (refundInfo.imgs && String(refundInfo.imgs).length) {
            refundInfo.imgs = refundInfo.imgs.split(',');
            this.form.up_imgs = _.cloneDeep(this.form.imgs);
            refundInfo.imgs.forEach((url) => {
              this.form.imgs.push({
                src: url,
                tagId: guid(),
              });
            });
          }
        }
      } catch (error) {
        this.$toast(`获取详情失败:${error.message}`);
      }
    },
    async submitForm() {
      const {
        form,
        form: { typeTitle, reason },
      } = this;
      if (this.goodsFrom === 'linkedMall') {
        const lmReason = this.lmReasonList.filter(f => f.reasonTextId === form.reasonKey);
        if (lmReason.refundDescRequired && !form.describe) {
          this.$toast('请填写售后说明');
        }
        if (lmReason.proofRequired && form.imgs.length === 0) {
          this.$toast('请上传售后凭证');
        }
      }
      if (!typeTitle) {
        this.$toast('请选择售后类型');
        return;
      }
      if (!reason) {
        this.$toast('请选择退款原因');
        return;
      }
      const nowForm = _.cloneDeep(form);
      delete nowForm.typeTitle;
      delete nowForm.statusTitle;
      delete nowForm.imgs;
      nowForm.goodsFrom = this.goodsFrom;
      this.$loading.open();
      try {
        const id = await orderApi.refundApply(nowForm);
        this.$router.push({ path: '/refund/detail', query: { id } });
      } catch (error) {
        this.$toast(`提交失败:${error.message}`);
      }
      this.$loading.close();
    },
    delteImg(index, tagId) {
      this.form.imgs.splice(index, 1);
      const { files, up_imgs } = this.form;
      this.form.files = files.filter(f => f.tagId !== tagId);
      this.form.up_imgs = up_imgs.filter(f => f.tagId !== tagId);
    },
    uploadPic(e) {
      const files = e.target.files || e.dataTransfer.files;
      const upImgs = this.form.up_imgs;
      const { length } = this.form.files;
      if (!files.length) {
        return;
      } else if (files.length > 4 || length + files.length + upImgs.length > 4) {
        this.$toast({
          message: '最多上传4张图片',
          duration: 1000,
        });
        return;
      } else if (files.length === 4 || length + files.length === 4) {
        this.isShowInput = false;
      }
      Object.keys(files).forEach((key) => {
        const val = files[key];
        val.tagId = guid(); /* 分配一个id */
        const reader = new FileReader();
        reader.readAsDataURL(val);
        reader.onload = (e) => {
          const dataURL = reader.result;
          const img = new Image();
          img.src = dataURL;
          img.onload = () => {
            const w = Math.min(400, img.width);
            const h = img.height * (w / img.width);
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = w;
            canvas.height = h;
            ctx.drawImage(img, 0, 0, w, h);
            const dataURL = canvas.toDataURL('image/png');
            const file = this.dataURLtoFile(dataURL, val.name);
            this.form.files.push(file);
          };
          this.form.imgs.push({
            src: e.target.result,
            tagId: val.tagId,
          });
        };
      });
    },
    dataURLtoFile(dataurl, filename) {
      // 将base64转换为文件
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n >= 0) {
        u8arr[n] = bstr.charCodeAt(n);
        n -= 1;
      }
      return new File([u8arr], filename, { type: mime });
    },
  },
};
</script>

<style lang="scss">
.refund-apply {
  height: 100%;
  padding-bottom: 140px;
  box-sizing: border-box;

  &__main {
    height: 100%;

    section {
      background: #fff;
      margin: 20px 0;
      font-size: 28px;
    }
  }

  &__goods {
    padding: 30px;
    display: flex;

    img {
      width: 150px;
      height: 150px;
      margin-right: 30px;
    }

    div {
      flex: 1;

      p {
        word-break: break-all;
        margin-top: 12px;
        font-size: 26px;
        color: #000;
      }

      p:last-child {
        color: #4a4a4a;
      }
    }
  }

  &__common {
    height: 72px;
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__picker {
    @extend .refund-apply__common;

    span:nth-child(1) {
      width: 140px;
    }

    span:nth-child(2) {
      flex: 1;
      text-align: right;
      margin-right: 15px;
    }
  }

  &__money {
    @extend .refund-apply__common;
    justify-content: flex-start;

    span:first-child {
      margin-right: 20px;
    }

    span:last-child {
      color: #ff4c00;
      font-weight: 600;
    }
  }

  &__reason {
    padding: 15px 0;
  }

  &__explain {
    margin-top: -20px;
    margin-bottom: -20px;
    font-size: 24px;
    color: #9b9b9b;
    padding: 0 30px;
    height: 70px;
    line-height: 70px;
  }

  &__remark {
    display: flex;
    padding: 15px 30px;
    align-items: center;

    span {
      height: 40px;
      margin-right: 20px;
    }

    &-input {
      flex: 1;
      height: 40px;
      font-size: 28px;
    }
  }

  &__certificate {
    background: #ffffff;

    textarea {
      width: 100%;
      font-size: 28px;
      word-break: break-all;
      border: none;
    }

    section:last-child {
      padding: 20px 0px 20px 30px;
      display: flex;
      flex-wrap: wrap;
    }

    .remark {
      margin-top: 20px;
      color: #777777;

      div {
        margin-top: 20px;

        span {
          vertical-align: top;
          margin-right: 10px;
        }

        img {
          width: 150px;
          height: 150px;
          margin-left: 10px;
        }
      }
    }
  }

  &__img {
    width: 148px;
    height: 148px;
    margin-right: 23px;
    margin-top: 20px;
    text-align: center;
    border-radius: 10px;
    position: relative;

    img {
      height: 100%;
      max-width: 100%;
      border-radius: 10px;
    }

    i {
      position: absolute;
      right: -15px;
      top: -20px;
    }
  }

  &__upload {
    width: 148px;
    height: 148px;
    margin-right: 23px;
    margin-top: 20px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 22px;
    color: #9b9b9b;
    border: 1px dashed #9b9b9b;
    border-radius: 10px;

    span {
      margin-top: 10px;
    }

    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }

  &__button {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px 36px;

    button {
      padding: 20px 0;
      width: 100%;
      font-size: 30px;
      color: #ffffff;
      background-image: linear-gradient(90deg, #fa841b 17%, #ff6002 85%);
      border-radius: 12px;
    }
  }
}
</style>

